<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-tooltip :top="top ? top : false">
        <template v-slot:activator="{ on }">
            <v-icon
                    v-on="on"
                    :color="color ? color : 'error'"
            >{{icon ? icon : 'error'}}</v-icon>
        </template>
        <span v-html="text"></span>
    </v-tooltip>
</template>

<script>
export default {
    name: 'TooltipIcon',
    props: ['color', 'icon', 'text', 'top']
}
</script>

<style scoped>

</style>
